import React from "react";
import MapRouteSidebar from "../components/MapRouteSidebar";
import AllMeasurements from "../components/AllMeasurements";
import { useData } from "../contexts/DataContext";

const DefaultRoute = () => {
  const { surfaceFeatures, surfaceTypes } = useData();

  return (
    <MapRouteSidebar noLink={true} title="Measurements">
      {surfaceFeatures.length === 0 ? (
        <div className="text-gray-700">No surfaces drawn</div>
      ) : (
        <AllMeasurements
          surfaceTypes={surfaceTypes}
          surfaceFeatures={surfaceFeatures}
        />
      )}
    </MapRouteSidebar>
  );
};

export default DefaultRoute;
